import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPuzzlePlugInAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.164 10.497a2.7 2.7 0 0 0-1.4.091 2.61 2.61 0 0 0-1.688 1.836 2.645 2.645 0 0 0 3.088 3.248v3.22c0 1.166.946 2.112 2.112 2.112h11.616a2.11 2.11 0 0 0 2.112-2.112V7.276a2.11 2.11 0 0 0-2.112-2.112H15.67a2.7 2.7 0 0 0-.091-1.4 2.61 2.61 0 0 0-1.836-1.688 2.645 2.645 0 0 0-3.248 3.088H7.275a2.11 2.11 0 0 0-2.112 2.112z"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13 10.5V14.5M15.001 12.5H11"
    />
  </svg>
);
export default SvgPuzzlePlugInAdd;
